<template>
  <modal transition="pop-out" name="new-outlet-modal" :height="550">
    <div class="w-full px-5 pt-4">
      <el-form :model="form" :label-position="labelPosition" :rules="rules" ref="form">
        <el-row class="mb-0">
          <el-col :xs="24">
            <el-form-item prop="name">
              <label class="text-sm block">Name:</label>
              <el-input class="w-full" v-model="form.name" type="text"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-0">
          <el-col :xs="24">
            <el-form-item prop="name">
              <label class="text-sm block">Unique Code/Identifier:</label>
              <el-input class="w-full" v-model="form.p_code" type="text" placeholder="Eg: ALG001"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row  :gutter="20" class="mb-0">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="address">
              <label class="text-sm block">Address:</label>
              <el-input class="w-full" v-model="form.address" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="country_id">
              <label class="text-sm block">Country:</label>
              <el-select class="w-full" v-model="form.country_id" filterable placeholder="Please select..."
                         @change="onGetStates($event)">
                <el-option
                  v-for="country in countries"
                  :key="country.id"
                  :label="country.name"
                  :value="country.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mb-0">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="state_id">
              <label class="text-sm block">State:</label>
              <el-select class="w-full" v-model="form.state_id" filterable placeholder="Please select..."
                         @change="onGetCities($event)">
                <el-option
                  v-for="state in states"
                  :key="state.id"
                  :label="state.name"
                  :value="state.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="city">
              <label class="text-sm block">City:</label>
              <el-input class="w-full" v-model="form.city" type="text"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mb-0">
          <el-col :xs="24" :sm="12">
            <el-form-item prop="status">
              <label class="text-sm block">Enable</label>
              <el-switch v-model="form.status"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :gutter="20">
          <el-button type="primary" @click="submit('form')" :loading="adding">Save</el-button>
          <el-button @click="closeDialog" type="info">Cancel</el-button>
        </el-form-item>
      </el-form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewOutletForm',
  data() {
    return {
      adding: false,
      labelPosition: 'top',
      rules: this.$store.state.OutletModule.validate_form,
    };
  },
  computed: {
    form() {
      return this.$store.state.OutletModule.new_outlet;
    },
    countries() {
      return this.$store.state.SettingsModule.Location.countries.data;
    },
    states() {
      return this.$store.state.SettingsModule.Location.states;
    },
    cities() {
      return this.$store.state.SettingsModule.Location.cities;
    },
  },
  methods: {
    async closeDialog() {
      this.$modal.hide('new-outlet-modal');
    },
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          try {
            this.adding = true;
            await this.$store.dispatch('OutletModule/newOutlet', { outlet: this.form });
            await this.$router.push(`/ecommerce/outlets/${
              this.$store.state.OutletModule.outlet.id
            }/details`);
            this.$modal.hide('new-outlet-modal');
            this.$notify.success({
              title: 'Success',
              message: 'New outlet successfully added',
            });
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.adding = false;
        } else {
          return false;
        }
      });
    },
    async onGetStates(countryId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantStates', { countryId });
    },
    async onGetCities(stateId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCities', { stateId });
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    const page = 1; const limit = 1000;
    try {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCountries', { page, limit });
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>

</style>
